export default __webpack_public_path__ + "images/Lci-text-right.dde0113601e55004d11bb7407b9ec2fa.png";